// src/components/ImpersonationBanner.js
// Persistent banner shown on every route while an admin is "viewing as" another user.
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  const handleExit = () => {
    stopImpersonation();
    navigate('/dashboard');
  };

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9998,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: '10px 16px',
        background: '#922b3f',
        color: 'white',
        fontSize: '0.85rem',
        fontWeight: 600,
        flexWrap: 'wrap',
        textAlign: 'center',
      }}
    >
      <span>
        Viewing as {impersonatedUser?.displayName || impersonatedUser?.email}
        {impersonatedUser?.email ? ` (${impersonatedUser.email})` : ''}
        {impersonatedUser?.role ? ` · ${impersonatedUser.role.replace('_', ' ')}` : ''} — read-only
      </span>
      <button
        onClick={handleExit}
        style={{
          background: 'rgba(255,255,255,0.15)',
          border: '1px solid rgba(255,255,255,0.4)',
          color: 'white',
          borderRadius: 6,
          padding: '4px 12px',
          fontSize: '0.78rem',
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Exit
      </button>
    </div>
  );
}
